import React from 'react'
import { Link } from 'react-router-dom';

const BannerOne = () => {
    return (
        <>
            <style>
                {`
                    .banner-item.arrow-center {
                        background: url("/banerdeci.png") center 35% / cover no-repeat !important;
                        background-color: #1a1208;
                        min-height: clamp(440px, 54vw, 640px);
                        display: flex;
                        align-items: stretch;
                    }

                    .banner-item.arrow-center::before {
                        content: '';
                        position: absolute;
                        inset: 0;
                        background:
                            linear-gradient(
                                180deg,
                                rgba(10, 7, 4, 0.62) 0%,
                                rgba(10, 7, 4, 0.28) 38%,
                                rgba(10, 7, 4, 0.08) 58%,
                                rgba(10, 7, 4, 0.35) 100%
                            );
                        z-index: 1;
                        pointer-events: none;
                        border-radius: inherit;
                    }

                    .banner-item.arrow-center .banner-hero-inner,
                    .banner-item.arrow-center > .scroll-down {
                        position: relative;
                        z-index: 2;
                    }

                    .banner-hero-inner {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        padding: clamp(2.5rem, 7vw, 4.5rem) clamp(1rem, 4vw, 2rem) 5.5rem;
                    }

                    .banner-hero-panel {
                        max-width: 780px;
                        width: 100%;
                        text-align: center;
                        padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 4vw, 2.5rem);
                    }

                    .banner-hero-eyebrow {
                        display: inline-block;
                        margin-bottom: 1rem;
                        font-size: 0.85rem;
                        font-weight: 600;
                        letter-spacing: 0.18em;
                        text-transform: uppercase;
                        color: #d4b06a;
                    }

                    .banner-item.arrow-center .banner-item__title {
                        color: #ffffff !important;
                        text-shadow: 0 2px 24px rgba(0, 0, 0, 0.4);
                        font-weight: 700;
                        letter-spacing: -0.02em;
                        line-height: 1.08;
                        margin-bottom: 1rem !important;
                        font-size: clamp(2rem, 4.8vw, 3.5rem) !important;
                    }

                    .banner-hero-subtitle {
                        max-width: 560px;
                        margin: 0 auto 1.75rem;
                        font-size: clamp(0.95rem, 1.8vw, 1.125rem);
                        line-height: 1.65;
                        color: rgba(255, 255, 255, 0.88);
                        text-shadow: 0 1px 12px rgba(0, 0, 0, 0.35);
                    }

                    .banner-item.arrow-center .banner-hero-btn {
                        display: inline-flex;
                        align-items: center;
                        gap: 0.6rem;
                        padding: 0.9rem 2rem;
                        font-weight: 600;
                        font-size: 0.95rem;
                        color: #1a1208 !important;
                        background: linear-gradient(135deg, #d4b06a 0%, #c5a05e 50%, #b8934a 100%) !important;
                        border: none !important;
                        border-radius: 999px;
                        box-shadow: 0 10px 32px rgba(0, 0, 0, 0.28);
                        transition: transform 0.25s ease, box-shadow 0.25s ease;
                        text-decoration: none;
                    }

                    .banner-item.arrow-center .banner-hero-btn:hover {
                        color: #1a1208 !important;
                        transform: translateY(-2px);
                        box-shadow: 0 14px 36px rgba(197, 160, 94, 0.45);
                    }

                    .banner-item.arrow-center > .scroll-down {
                        border-color: #c5a05e !important;
                        background: rgba(10, 7, 4, 0.75) !important;
                        backdrop-filter: blur(4px);
                    }

                    @media (max-width: 767px) {
                        .banner-item.arrow-center {
                            background-position: 55% 30%;
                            min-height: 500px;
                        }

                        .banner-item.arrow-center::before {
                            background:
                                linear-gradient(
                                    180deg,
                                    rgba(10, 7, 4, 0.68) 0%,
                                    rgba(10, 7, 4, 0.35) 45%,
                                    rgba(10, 7, 4, 0.2) 100%
                                );
                        }

                        .banner-hero-inner {
                            align-items: center;
                            padding-top: 2rem;
                            padding-bottom: 5rem;
                        }
                    }
                `}
            </style>
            <div className="banner">
                <div className="container container-lg">
                    <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center">
                        <a
                            href="#featureSection"
                            className="scroll-down scroll-down-black w-84 h-84 text-center flex-center rounded-circle border border-5 text-white position-absolute start-50 translate-middle-x bottom-0"
                        >
                            <span className="icon line-height-0">
                                <i className="ph ph-caret-double-down" />
                            </span>
                        </a>
                        <div className="banner-hero-inner">
                            <div className="banner-hero-panel">
                                <span className="banner-hero-eyebrow">
                                    Artisanat de Fès
                                </span>
                                <h1 className="banner-item__title">
                                    Le Khalie traditionnel,<br />préparé avec passion
                                </h1>
                                <p className="banner-hero-subtitle">
                                    Des saveurs authentiques et des recettes ancestrales,
                                    transmises de génération en génération.
                                </p>
                                <Link
                                    to="/shop"
                                    className="banner-hero-btn"
                                >
                                    Voir nos produits
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BannerOne
